export default "__VITE_ASSET__08ef39b4__"